import { Button } from '../button/button';
import { SearchHeaderStyled } from './search-header.styles';
import { EncircledPlusIcon } from '../../utils/svg-components';
import TextInputField from '../form-fields/text-input-field/text-input-field';
import { Typography } from '@mui/material';
import TableActionMenu from '../table-action-menu/table-action-menu';

const SearchHeader = ({
  heading,
  ctaTitle,
  ctaHandler,
  handleSearch,
  placeholder,
  optionsList,
  menuWidth,
}) => {
  const handleInputChange = (event) => {
    if (handleSearch) {
      handleSearch(event.target.value);
    }
  };
  return (
    <SearchHeaderStyled>
      <Typography variant={'h5'}> {heading}</Typography>

      <div className="search-field">
        <TextInputField placeholder={placeholder} onChange={handleInputChange} />
      </div>

      <div style={{ display: 'flex' }}>
        {ctaTitle && (
          <Button
            variant="filled"
            color={'tertiary'}
            onClick={ctaHandler}
            startIcon={<EncircledPlusIcon />}
          >
            {ctaTitle}
          </Button>
        )}

        {optionsList && (
          <div>
            <TableActionMenu options={optionsList} noBorder width={menuWidth || 180} />
          </div>
        )}
      </div>
    </SearchHeaderStyled>
  );
};

export default SearchHeader;
